<mat-card  class="plan-card" tabindex="-1" >
    <mat-card-header>
      <div mat-card-avatar class="example-header-image"></div>
      <h4>Welcome to your JanguKit Repository</h4>
    </mat-card-header>

    <mat-card-actions>
      <button class="access-btn" (click)="goToRepository()">
        <img src="./assets/github.svg" height="40px" alt="Google Logo" class="google-logo">
        Access to JanguKit Code base repository
      </button>
    </mat-card-actions>
  </mat-card>
